export default ({value, min, max}) => {
    let result = min === undefined ? value : Math.max(value, min) ;
    return max === undefined ? result : Math.min(result, max);
  };